import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/creator/image-2.webp")